import React from 'react';
import MUITable, {
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
} from 'material-ui-next/Table';
import {
  TablePaginationActions,
  EnhancedTableHead
} from '../../widgets/table_utils.react.js';
import Checkbox from 'material-ui-next/Checkbox';
import {
  Redirect
} from 'react-router-dom'
import CSSModules from 'react-css-modules';
import Chip from 'material-ui-next/Chip';
import styles from './all.css';
import Tooltip from 'material-ui-next/Tooltip';
import {
  CopyToClipboard
} from 'react-copy-to-clipboard';
import S3Icon from '../../assets/icons/s3Icon.react.js';
import IconButton from 'material-ui-next/IconButton';
import Menu, {
  MenuItem
} from 'material-ui-next/Menu';

import $ from "jquery";
import config from '../../config.json';

import { orange400 } from 'material-ui/styles/colors';
import CheckCircleIcon from 'material-ui-icons/CheckCircle';

class AdminDistTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      s3_menu_anchor: {},
      redirect: null,
      all_data: props.data,
      data: [],
      enableSelect: false,
      order: 'asc',
      orderBy: 'pkg',
      selected: [],
      page: 0,
      new_page: 0,
      rowsPerPage: 10,
      rowCount: 0,
      loading: false,
    }

    this.on_load_data = this.on_load_data.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleLevelreq = this.handleLevelreq.bind(this)
    this.refresh = this.refresh.bind(this)

    this.handleRequestSort = this.handleRequestSort.bind(this)
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    this.handleDownloadAction = this.handleDownloadAction.bind(this)
    this.isSelected = this.isSelected.bind(this)
    this.sortData = this.sortData.bind(this)

    this.get_column_configs = this.get_column_configs.bind(this)
    this.handleMenuOpen = this.handleMenuOpen.bind(this)
    this.handleMenuClose = this.handleMenuClose.bind(this)
    this.get_s3_info = this.get_s3_info.bind(this)
  }

  get_column_configs(return_dict) {
    const columnConfigs = [
      {
        id: 'pkg',
        numeric: false,
        disablePadding: false,
        label: 'Package',
        data: (raw) => {
          return raw.service
        }
      },
      {
        id: 'system',
        numeric: false,
        disablePadding: false,
        label: 'System',
        data: (raw) => {
          return raw.system
        }
      },
      {
        id: 'platform',
        numeric: false,
        disablePadding: false,
        label: 'platform',
        data: (raw) => {
          return raw.platform
        }
      },
      {
        id: 'version',
        numeric: true,
        disablePadding: false,
        label: 'Version',
        data: (raw) => {
          return raw.version
        }
      },
      {
        id: 'level',
        numeric: true,
        disablePadding: false,
        label: 'API level',
        data: (raw) => {
          return raw.level
        }
      },
      {
        id: 's3',
        numeric: false,
        disablePadding: false,
        label: 'Details',
        disableSort: true
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'Actions',
        disableSort: true
      }
    ]

    if (return_dict) {
      return columnConfigs.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    }

    return columnConfigs
  }

  sortData(data, order, orderBy) {
    var self = this;

    const _data =
      order === 'desc' ?
      data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (vb < va) ? -1 : 1
        }
      ) :
      data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (va < vb) ? -1 : 1
        }
      );

    this.setState({
      order,
      orderBy,
      data: _data,
      loading: false
    });
  }

  handleRequestSort(event, property) {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.sortData(this.state.data, order, orderBy)
  }

  handleSelectAllClick(event, checked) {
    if (checked) {
      this.setState({
        selected: this.state.data.map(n => n.id)
      });
      return;
    }
    this.setState({
      selected: []
    });
  }

  handleClick(event, id) {
    const {
      selected
    } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({
      selected: newSelected
    })
  }

  handleChangePage(event, page) {
    this.setState({
      selected: [],
      data: this.state.all_data.slice(
        page * this.state.rowsPerPage,
        page * this.state.rowsPerPage + this.state.rowsPerPage
      ),
      page: page
    }, () => {
      /* this.refresh(
       *   page * this.state.rowsPerPage
       * )*/
      this.sortData(this.state.data, this.state.order, this.state.orderBy)
    });
  }

  handleChangeRowsPerPage(event) {
    const rowsPerPage = event.target.value;
    this.setState({
      rowsPerPage: rowsPerPage,
      selected: [],
      data: this.state.all_data.slice(
        this.state.page * rowsPerPage,
        this.state.page * rowsPerPage + rowsPerPage
      )
    }, () => {
      /* this.refresh(
       *   this.state.new_page * this.state.rowsPerPage,
       *   this.state.rowsPerPage
       * )*/
      this.sortData(this.state.data, this.state.order, this.state.orderBy)
    });
  }

  /**
   * Handle download package action
   */
  handleDownloadAction = (dist) => (event) => {
    $.get({
      dataType: 'json',
      url: `${config.server + config.api_path}/dist/url/${dist.id}`,
      xhrFields: {
        withCredentials: true
      }
    })
    .done((data) => {
      if (data.err && data.err.ec === 0) {
        const { url } = data.ret;
        window.open(url, "_blank");
      } else if (data.err && data.err.ec === 403) {
        this.props.unauthorized();
      }
    })
  }

  isSelected(id) {
    return this.state.selected.indexOf(id) !== -1
  }

  refresh(offset, rowsPerPage) {
    this.setState(
      {loading: true}, () => {
        this.props.load_data(
          rowsPerPage || this.state.rowsPerPage,
          offset || this.state.new_page * this.state.rowsPerPage,
          this.on_load_data
        )
      }
    )
  }

  on_load_data(all_dist) {
    this.setState({
      all_data: all_dist.packages,
      rowCount: all_dist.packages.length,
      page: this.state.new_page
    }, () => {
      const data = this.state.all_data.slice(
        this.state.page * this.state.rowsPerPage,
        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
      )
      this.sortData(data, this.state.order, this.state.orderBy)
    })
  }

  componentWillMount() {
    this.refresh()
  }

  handleDelete(data) {
    var self = this;
    return (e) => {
      self.props.open_delete(data)
    }
  }

  handleMenuClose(name) {
    var self = this;
    return (e) => {
      self.setState({
        [name]: {},
      })
    }
  }

  handleMenuOpen(name, id) {
    var self = this;
    return (e) => {
      self.setState({
        [name]: {
          [id]: e.currentTarget
        },
      })
    }
  }

  handleLevelreq(data) {
    var self = this;
    return (e) => {
      self.props.open_levelreq(data)
    }
  }

  get_s3_info(data) {
    const id = data.id
    const {
      s3_menu_anchor
    } = this.state
    return (
      <div>
        <Tooltip title="S3" placement="top" disableTriggerFocus={true}>
          <IconButton onClick={this.handleMenuOpen("s3_menu_anchor", id)}>
            <S3Icon />
          </IconButton>
        </Tooltip>
        <Menu
          key="s3-menu"
          anchorEl={s3_menu_anchor[id]}
          open={Boolean(s3_menu_anchor[id])}
          onClose={this.handleMenuClose("s3_menu_anchor")}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        >
          <CopyToClipboard
            text={data.s3_bucket}
            onCopy={this.handleMenuClose("s3_menu_anchor")}>
            <MenuItem key="bucket" disabled={false}>
              Bucket: {data.s3_bucket}
            </MenuItem>
          </CopyToClipboard>
          <CopyToClipboard
            text={data.s3_key}
            onCopy={this.handleMenuClose("s3_menu_anchor")}>
            <MenuItem key="key" disabled={false}>
              Key: {data.s3_key}
            </MenuItem>
          </CopyToClipboard>
        </Menu>
      </div>
    )
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    const columnConfigs = this.get_column_configs()
    const {
      loading,
      data,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      rowCount,
      enableSelect
    } = this.state;
    const emptyRows = rowsPerPage - data.length;
    return (
      <MUITable styleName="admin-table">
        <EnhancedTableHead
          loading={loading}
          enableSelect={enableSelect}
          numSelected={selected.length}
          onRequestSort={this.handleRequestSort}
          onSelectAllClick={this.handleSelectAllClick}
          order={order}
          orderBy={orderBy}
          rowCount={data.length}
          columnConfigs={columnConfigs}
        >
        </EnhancedTableHead>
        <TableBody>
          {
            this.state.data.map((info) => {
              const isSelected = this.isSelected(info.id);
              var actions = [
                (
                  <Chip
                    styleName="admin-table-action"
                    key="download"
                    label="Download"
                    onClick={this.handleDownloadAction(info)}
                  />
                ),
                (
                  <Chip
                    styleName="admin-table-action"
                    key="level"
                    label="Level"
                    onClick={this.handleLevelreq(info)}
                  />
                ),
                (
                  <Chip
                    styleName="admin-table-action"
                    key="del"
                    label="Delete"
                    onClick={this.handleDelete(info)}
                  />
                )
              ]

              const s3_info = this.get_s3_info(info)
              return (
                <TableRow key={info.id} aria-checked={isSelected} selected={isSelected}>
                  {enableSelect && (
                     <TableCell
                       padding="checkbox"
                       onClick={(event) => {this.handleClick(event, info.id)}}
                       >
                       <Checkbox checked={isSelected} />
                     </TableCell>
                  )}
                  <TableCell>
                    <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'flex-end' }}>
                      <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                        {info.service}
                      </div>
                      { (info.tags.includes('latest')) && (
                        <div style={{ marginLeft: 'auto' }}>
                          <CheckCircleIcon color={orange400} />
                        </div>
                      )}
                    </div>
                  </TableCell>
                  <TableCell>{info.system}</TableCell>
                  <TableCell>{info.platform}</TableCell>
                  <TableCell numeric={true}>{info.version}</TableCell>
                  <TableCell numeric={true}>{info.level}</TableCell>
                  <TableCell styleName="admin-table-icon-cell">{s3_info}</TableCell>
                  <TableCell>
                    <div>
                      {actions}
                    </div>
                  </TableCell>
                </TableRow>
              )
            })
          }
          {emptyRows > 0 && (
             <TableRow>
               <TableCell colSpan={6} />
             </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={10}
              count={rowCount}
              rowsPerPageOptions={[10, 25, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              Actions={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </MUITable>
    )
  }
}

AdminDistTable.defaultProps = {
  data: [],
  load_data: null,
  open_delete: null
}

export default CSSModules(AdminDistTable, styles)



// WEBPACK FOOTER //
// ./src/views/admin/dist_table.react.js